export const pluginTypes = {
  PIP: 'PIP',
  CAROUSEL: 'CAROUSEL',
  VLP: 'VLP',
  EMBED: 'EMBED'
};

export const PLUGIN_TYPES = {
  CAROUSEL: 'CAROUSEL',
  GALLERY: 'GALLERY',
  PLAYLIST: 'PLAYLIST',
  LIST: 'LIST'
};



// WEBPACK FOOTER //
// ./src/constants/plugin-types.js